/* Make/model info tabs (T650 proof): dynamic Specifications (driven by the picker's
   mmf:track-selected event) + premium rebuild of the Warranty and Shipping & Returns tabs. */
(function(){
  var ICON = {
    shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 4H2v11h12z"/><path d="M14 8h5l3 3v4h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    ret:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7v6h6"/><path d="M3.5 13a9 9 0 1 0 2.6-6.4L3 9"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    star:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 2.9 5.9 6.1.9-4.5 4.3 1.1 6.4L12 17.8 6.4 20.5l1.1-6.4L3 9.8l6.1-.9z"/></svg>',
    tag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 12 22l-9-9V3h10z"/><circle cx="7.5" cy="7.5" r="1.3" fill="currentColor" stroke="none"/></svg>',
    fit:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.3 2.3 4.7-4.6"/></svg>'
  };
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  // Task 9938: the machine page names a track only as Heavy Duty or Premium, never by
  // its series ("X Series", "HDX Series", "Pro Series"). The picked track's own
  // description and the related-product titles carry the series, so strip it from
  // visible text ("The UltraTrack Pro Series 13\"" -> "The UltraTrack 13\"").
  // A series line is a series token (the vocabulary of ut_sku.ex: HDX, X, Pro, Premium,
  // AG) plus up to four more words, then "Series": so every multi-word line ("Pro CTL",
  // "Pro Compact", "Pro Paver", "Pro Mini Compact", "Pro Carrier Dumper", "Pro Ag", and
  // the mistyped live title "Pro Mini Compact Machine, Excavator, Series") without
  // listing each one. Machine and part names that merely end in "Series"
  // ("Kubota U35-3 SUPER SERIES", "SVL Series") don't start with a token and stay.
  // The phrase stays on one line and never runs through the words of a track name
  // ("... AG Rubber Track" then "UltraTrack Pro Series" keeps "AG Rubber Track").
  var SERIES_RE = /\s*\b(?:HDX|X|Pro|Premium|AG)(?:[ \t ,-]+(?!(?:Rubber|Tracks?|Ultra[A-Za-z]*)\b)[A-Za-z]+){0,4}?[ \t ,-]+Series\b/gi, HAS_SERIES = new RegExp(SERIES_RE.source, 'i');
  function noSeries(s){ return String(s == null ? '' : s).replace(SERIES_RE, ''); }
  function scrubSeries(el){
    if(!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while((n = w.nextNode())){ if(HAS_SERIES.test(n.nodeValue)) n.nodeValue = noSeries(n.nodeValue); }
  }

  // The 30-month warranty is a RUBBER TRACK claim (task 10268). This script also loads on
  // non-track products that share the template (e.g. Over Tire Tracks), so the 30-month
  // copy is limited to rubber-track product types. Unknown type = legacy behaviour.
  var PT = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.type) || '';
  var IS_RUBBER_TRACK = !PT || /^(Mfg-Models|Tracks|Rubber Tracks)$/i.test(PT);

  // ---- Description ----
  var GUARANTEES = [
    { ic: 'fit',    t: 'Perfect Fit Guarantee',   d: 'Engineered to OEM specs for your machine — fits perfectly or your money back.' },
    IS_RUBBER_TRACK
      ? { ic: 'shield', t: '30-Month Warranty',        d: 'Industry-leading coverage — 2.5 years against manufacturing defects.' }
      : { ic: 'shield', t: 'Manufacturer Warranty',    d: 'Guaranteed free from defects in materials and workmanship.' },
    { ic: 'truck',  t: 'Free Same-Day Shipping',   d: 'Ships free the same business day from 23 warehouses nationwide.' }
  ];
  function enhanceDescription(){
    var panel = document.getElementById('pp-tab-desc'); if(!panel || panel.__mm) return;
    var card = panel.querySelector('.pp-card'); if(!card) return; panel.__mm = 1;
    var descEl = card.querySelector('.pp-tab-content.rte');
    var descHtml = descEl ? descEl.innerHTML.trim() : '';
    var kf = [];
    var dataEl = document.getElementById('mm-desc-data');
    if(dataEl){ try { kf = (JSON.parse(dataEl.textContent).key_features) || []; } catch(e){} }
    var html = '';
    if(descHtml) html += '<div class="mm-info-card mm-desc-intro">' + descHtml + '</div>';
    if(kf.length){
      html += '<div class="mm-info-card"><div class="mm-info-head">' + ICON.star + '<h3>Key Features</h3></div>'
        + '<ul class="mm-feat">' + kf.map(function(f){ return '<li>' + ICON.check + '<span>' + esc(f) + '</span></li>'; }).join('') + '</ul></div>';
    }
    html += '<div class="mm-adv-grid">' + GUARANTEES.map(function(g){
      return '<div class="mm-adv"><div class="mm-adv-ic">' + ICON[g.ic] + '</div><div><strong>' + esc(g.t) + '</strong><span>' + esc(g.d) + '</span></div></div>';
    }).join('') + '</div>';
    card.innerHTML = html;
  }

  // ---- Warranty ----
  function enhanceWarranty(){
    var panel = document.getElementById('pp-tab-warranty'); if(!panel || panel.__mm) return;
    // Solid and pneumatic tires carry a 12-month manufacturer warranty, rubber tracks 30.
    // If the server already rendered tire warranty copy, never overwrite it with track copy.
    if(/12[\s-]*month/i.test(panel.textContent || '')) { panel.__mm = 1; return; }
    // Non-rubber-track products keep the server-rendered warranty copy.
    if(!IS_RUBBER_TRACK) { panel.__mm = 1; return; }
    panel.__mm = 1;
    panel.innerHTML =
      '<div class="mm-info-card">'
      + '<div class="mm-info-head">' + ICON.shield + '<h3>30-Month Manufacturer Warranty</h3><span class="mm-badge">Longest in the industry</span></div>'
      + '<p>Every UltraTrack rubber track is backed by a 30-month manufacturer warranty against defects in materials and workmanship — the longest warranty in the aftermarket rubber track industry. If something isn\'t right, we make it right.</p>'
      + '<ul class="mm-feat">'
      +   '<li>' + ICON.check + '<span>30-month coverage against manufacturing defects</span></li>'
      +   '<li>' + ICON.check + '<span>Guaranteed fitment for the listed make &amp; model</span></li>'
      +   '<li>' + ICON.check + '<span>Fitment &amp; warranty support 7 days a week</span></li>'
      + '</ul>'
      + '<div class="mm-info-foot">Questions about coverage? Call <a href="tel:8665168473">(866) 516-8473</a>.</div>'
      + '</div>';
  }

  // ---- Shipping & Returns ----
  function enhanceShipping(){
    var panel = document.getElementById('pp-tab-shipping'); if(!panel || panel.__mm) return; panel.__mm = 1;
    panel.innerHTML =
      '<div class="mm-info-card">'
      + '<div class="mm-chips"><span class="mm-chip">Free shipping</span><span class="mm-chip">Same-day processing</span><span class="mm-chip">30-day returns</span></div>'
      + '<div class="mm-ship-grid">'
      +   '<div class="mm-ship-block"><div class="mm-info-head">' + ICON.truck + '<h3>Shipping</h3></div>'
      +     '<p>Free shipping on every order to all 50 US states — no minimum. Orders placed before 2 PM CST are processed and shipped the same business day from the nearest of our 23 US warehouses.</p></div>'
      +   '<div class="mm-ship-block"><div class="mm-info-head">' + ICON.ret + '<h3>Returns</h3></div>'
      +     '<p>30-day hassle-free returns on unused products in original packaging. If a track doesn\'t fit due to an error on our part, we cover return shipping.</p></div>'
      + '</div>'
      + '</div>';
  }

  // ---- Specifications (dynamic, per selected track) ----
  function specsHost(){
    var panel = document.getElementById('pp-tab-specs'); if(!panel) return null;
    var host = document.getElementById('mm-spec-host');
    if(!host){
      var card = panel.querySelector('.pp-card');   // own the first specs card; leave alt-tread/same-size cards intact
      if(!card) return null;
      card.innerHTML = '<div id="mm-spec-host"></div>';
      host = document.getElementById('mm-spec-host');
    }
    return host;
  }
  function row(k, v){ return '<div class="mm-spec-row"><span class="mm-spec-k">' + esc(k) + '</span><span class="mm-spec-v">' + esc(v) + '</span></div>'; }
  function renderSpecs(d){
    var host = specsHost(); if(!host) return;
    if(!d || !d.size){
      // Picker-aware empty state: only prompt "select above" when a picker actually exists (~9% of
      // make/model pages have no compatible_tracks_json, so no picker — show a call CTA instead).
      host.innerHTML = document.querySelector('.mmf-wrap')
        ? '<div class="mm-spec-empty">Select a tread and size above to see the full specifications for that exact track.</div>'
        : '<div class="mm-spec-empty">Track specifications vary by size. Call <a href="tel:8665168473" style="color:#4fc3f7;font-weight:700">(866) 516-8473</a> and we\'ll confirm the exact spec for your machine.</div>';
      return;
    }
    var p = String(d.size).split(/[x×]/i), w = p[0] || '', pitch = p[1] || '', links = p[2] || '';
    var inStock = (d.inv > 0) || (d.qty > 0);
    var rows = row('Size', d.size);
    if(w) rows += row('Width', w + ' mm');
    if(pitch) rows += row('Pitch', pitch + ' mm');
    if(links) rows += row('Links', links);
    if(d.tread) rows += row('Tread pattern', d.tread);
    if(d.constr) rows += row('Construction', d.constr);
    rows += row('Condition', 'New');
    rows += row('Brand', 'UltraTrack');
    host.innerHTML =
      '<div class="mm-spec-hero">'
      + '<div><div class="mm-spec-hero-size">' + esc(d.size) + '</div>'
      + '<div class="mm-spec-hero-sub">' + esc(d.tread || '') + (d.constr ? ' · ' + esc(d.constr) : '') + '</div></div>'
      + '<span class="mm-spec-stock ' + (inStock ? 'in' : 'out') + '">'
      +   (inStock ? 'In stock' + (d.qty ? ' · ' + d.qty + ' available' : '') : 'Call to order')
      + '</span></div>'
      + '<div class="mm-spec-grid">' + rows + '</div>';
  }

  // ---- Dynamic Description (the SELECTED track's real product description) ----
  // Uses Shopify's Section Rendering API to pull the picked track's rendered main-product
  // section, then injects its Description panel into the make/model Description tab.
  var _trackSection = {};
  function fetchTrackSection(handle){
    if(_trackSection[handle]) return Promise.resolve(_trackSection[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=main-product')
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){ if(!html) return null; var doc = new DOMParser().parseFromString(html, 'text/html'); _trackSection[handle] = doc; return doc; })
      .catch(function(){ return null; });
  }
  function renderTrackDescription(handle){
    if(!handle) return;
    var panel = document.getElementById('pp-tab-desc'); if(!panel) return;
    fetchTrackSection(handle).then(function(doc){
      if(!doc) return;
      var src = doc.querySelector('#pp-tab-desc .pp-card') || doc.querySelector('#pp-tab-desc');
      // Wrap in the solid .mm-info-card so it matches the other enhanced tabs (not the
      // transparent .pp-card, which lets the video background show through).
      if(src && src.innerHTML.trim()){ panel.innerHTML = '<div class="mm-info-card mm-desc-card">' + src.innerHTML + '</div>'; scrubSeries(panel); }
    });
  }

  // ---- Dynamic Related Products (the SELECTED track's cross-sell) ----
  var API = 'https://app.team1texas.com/apps/portal', API_TOKEN = 'sf_t1t_a8f3e2d1c4b5967081234abcdef56789', _pe = {};
  function fetchEnhance(handle){
    if(_pe[handle]) return Promise.resolve(_pe[handle]);
    return fetch(API + '/product-enhance/' + encodeURIComponent(handle), { headers: { 'Accept': 'application/json', 'X-Api-Token': API_TOKEN } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ var d = (j && j.data) || null; _pe[handle] = d; return d; })
      .catch(function(){ return null; });
  }
  function renderRelated(handle){
    var host = document.getElementById('portal-cross-sell-content'), btn = document.getElementById('pp-parts-tab'), badge = document.getElementById('pp-parts-tab-badge');
    if(!host) return;
    fetchEnhance(handle).then(function(d){
      var cs = (d && d.cross_sell) || [];
      if(!cs.length){ if(btn) btn.style.display = 'none'; return; }
      host.innerHTML = '<div class="pe-parts-grid">' + cs.map(function(p){
        var img = p.featured_image ? '<div class="pe-part-img"><img src="' + p.featured_image + '" alt="" loading="lazy"></div>' : '';
        var stock = p.in_stock ? '<span class="pe-part-stock in">In Stock</span>' : '<span class="pe-part-stock out">Call for Availability</span>';
        return '<a class="pe-part-card" href="' + (p.url || '/products/' + p.handle) + '">' + img
          + '<div class="pe-part-body"><div class="pe-part-title">' + esc(noSeries(p.title)) + '</div>'
          + (p.price ? '<div class="pe-part-price">' + esc(p.price) + '</div>' : '') + stock + '</div></a>';
      }).join('') + '</div>';
      if(btn) btn.style.display = '';
      if(badge){ badge.textContent = cs.length; badge.style.display = ''; }
    });
  }

  // ---- Dynamic Reviews (the SELECTED track's reviews; server-rendered HTML, no Judge.me JS needed) ----
  // Only show the tab when the track has ACTUAL reviews (.jdgm-rev elements); "Be the first to
  // write a review" / no panel = no reviews = hide the tab (per requirement).
  function renderReviews(handle){
    var host = document.getElementById('mm-reviews-host'), btn = document.getElementById('pp-mm-reviews-tab');
    if(!host) return;
    fetchTrackSection(handle).then(function(doc){
      var panel = doc ? doc.querySelector('#pp-tab-reviews') : null;
      var actual = panel ? panel.querySelectorAll('.jdgm-rev').length : 0;
      if(panel && actual > 0){
        var card = panel.querySelector('.pp-card') || panel;
        host.innerHTML = card.innerHTML;
        scrubSeries(host);
        if(btn) btn.style.display = '';
      } else {
        host.innerHTML = '';
        if(btn) btn.style.display = 'none';
      }
    });
  }

  function applySelection(d){
    d = d || {};
    renderSpecs(d);
    if(d.handle){ renderTrackDescription(d.handle); renderRelated(d.handle); renderReviews(d.handle); }
  }
  function init(){
    enhanceDescription(); scrubSeries(document.getElementById('pp-tab-desc')); enhanceWarranty(); enhanceShipping(); renderSpecs(null);
    // Single-track make/model pages auto-resolve their one track on load and dispatch
    // BEFORE this deferred script registers its listener — so pick up any prior selection.
    if(window.__mmfSelected) applySelection(window.__mmfSelected);
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('mmf:track-selected', function(e){ applySelection(e.detail); });
})();
